/* AGM · Home v2 — hero de video, previews de producto, aparición al scroll.
   Regla de carga: nada de video se descarga hasta que la página terminó de cargar
   (window.load) y nunca en ahorro de datos / conexión 2g. Antes de eso solo hay pósters. */
(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var save = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');

  /* Cuánto se espera, desde que el slide actual arranca, para empezar a bajar
     el siguiente. Con 6s por slide le quedan ~4,8s de ventaja: llega buffereado. */
  var ESPERA_MS = 1200;

  /* ¿Hay que bajar la calidad? No depende del tamaño de la pantalla sino de la
     conexión y del equipo: un celular con 4G ve mejor el 720p y le cuesta lo mismo. */
  function apretado(){
    var t = conn.effectiveType || '';
    return save
      || /(^|-)(2g|3g)$/.test(t)
      || (typeof conn.downlink === 'number' && conn.downlink > 0 && conn.downlink < 1.6)
      || (navigator.deviceMemory && navigator.deviceMemory <= 2);
  }
  /* 26-sep-2026: el celular recibía el 720p de 3–4,5 Mbps (hasta 6 MB por video) y se trababa.
     Ahora data-sd es la versión hecha para el celular (vertical en la portada, 480 px en las demos,
     sin audio, 0,2–0,5 MB) y data-hd la del PC. Pantallas bajo 750 px siempre usan data-sd. */
  function pick(el){
    var hd = el.dataset.hd || el.dataset.sd || '';
    var sd = el.dataset.sd || hd;
    /* 10-oct-2026: en pantallas de 750 px o más SIEMPRE va el video horizontal (data-hd). Antes, si el navegador
       calculaba una conexión baja (downlink < 1,6), el PC recibía el video vertical de celular recortado. */
    return innerWidth < 750 ? sd : hd;
  }
  function whenLoaded(fn){
    var go = function(){ (window.requestIdleCallback || function(f){ setTimeout(f, 250); })(fn); };
    if(document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
  }
  /* 3-oct-2026: la portada ya no espera a que termine TODA la página (window.load) para su primer video:
     arranca apenas el HTML está armado. Esperar el load hacía que, con internet lento o con otras
     descargas en curso, los primeros videos no partieran. Las demos siguen esperando el load. */
  function whenReady(fn){
    if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }
  function play(v){ var p = v.play(); if(p && p.catch) p.catch(function(){}); }

  /* ---- aparición suave al hacer scroll ---- */
  var rv = [].slice.call(document.querySelectorAll('.agm .rv'));
  if(rv.length){
    if(!('IntersectionObserver' in window) || reduce){ rv.forEach(function(e){ e.classList.add('in'); }); }
    else {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
      rv.forEach(function(e){ io.observe(e); });
    }
  }

  /* ---- hero: carrusel de videos ---- */
  var hero = document.querySelector('[data-hero]');
  if(hero){
    var slides = [].slice.call(hero.querySelectorAll('.hslide'));
    var dots = [].slice.call(hero.querySelectorAll('.hdot'));
    var dyn = [].slice.call(hero.querySelectorAll('[data-dyn] > *'));
    var n = slides.length, idx = 0, timer = null, pre = null, ready = false, visible = true;
    var dur = (+hero.dataset.dur || 6) * 1000;
    hero.style.setProperty('--dur', dur + 'ms');

    var vid = function(i){ return slides[i] && slides[i].querySelector('video'); };
    /* Avisa (una vez) que el primer video ya corre: el panda 3D espera esta señal para descargarse
       y no le quita internet a la portada (ver layout/theme.liquid). */
    var avisado = false;
    function avisar(){ if(avisado) return; avisado = true; window.AGM_HERO_LISTO = true; dispatchEvent(new Event('agm:hero-listo')); }
    function load(i){
      var v = vid(i);
      if(!v || v.dataset.l || save || reduce || !pick(slides[i])) return;
      v.dataset.l = 1; v.preload = 'auto'; v.src = pick(slides[i]);
      v.addEventListener('playing', function(){ v.classList.add('ready'); avisar(); }, { once: true });
      v.addEventListener('error', avisar, { once: true });
    }
    function mark(){
      hero.classList.toggle("agm-poster-on", slides[idx].classList.contains("agmpack-poster"));
      slides.forEach(function(s, i){ s.classList.toggle('on', i === idx); });
      dyn.forEach(function(d){ d.classList.toggle('on', +d.dataset.i === idx); });
      dots.forEach(function(d, i){ d.classList.remove('on'); if(i === idx){ void d.offsetWidth; d.classList.add('on'); } });
    }
    function show(i){
      var old = vid(idx); if(old && i !== idx) old.pause();
      idx = (i + n) % n; mark();
      if(ready){ load(idx); var v = vid(idx); if(v && v.dataset.l){ v.currentTime = 0; play(v); } }
      arm();
    }
    /* El siguiente arranca su descarga poco después del actual, no junto con él. */
    function arm(){
      clearTimeout(timer); clearTimeout(pre);
      if(n <= 1 || !visible || document.hidden) return;
      if(ready) pre = setTimeout(function(){ load((idx + 1) % n); }, ESPERA_MS);
      timer = setTimeout(function(){ show(idx + 1); }, dur);
    }
    function halt(){ clearTimeout(timer); clearTimeout(pre); var v = vid(idx); if(v) v.pause(); hero.classList.add('paused'); }
    function resume(){ hero.classList.remove('paused'); var v = vid(idx); if(v && v.dataset.l) play(v); arm(); }

    dots.forEach(function(d, i){ d.addEventListener('click', function(){ show(i); }); });
    var x0 = null;
    hero.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function(e){
      if(x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if(Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
    document.addEventListener('visibilitychange', function(){ document.hidden ? halt() : (visible && resume()); });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        visible = es[0].isIntersecting; visible ? resume() : halt();
      }, { threshold: .15 }).observe(hero);
    }
    mark(); arm();
    whenReady(function(){ ready = true; load(0); var v = vid(0); if(v && v.dataset.l) play(v); else avisar(); arm(); });
  }

  /* ---- "Míralos en acción": preview al pasar el mouse / al entrar en pantalla ---- */
  var demos = [].slice.call(document.querySelectorAll('[data-demo]'));
  if(demos.length){
    var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
    var on = function(d){
      var v = d.querySelector('.dvid'), g = d.querySelector('.dgif');
      if(v){
        if(!v.dataset.l){
          v.dataset.l = 1; v.preload = 'auto'; v.src = pick(v);
          v.addEventListener('playing', function(){ v.classList.add('vplay'); });
        }
        play(v);
      } else if(g){ if(!g.getAttribute('src')) g.src = g.dataset.src; }
      d.classList.add('playing');
    };
    var off = function(d){
      var v = d.querySelector('.dvid'), g = d.querySelector('.dgif');
      if(v){ v.pause(); v.classList.remove('vplay'); }
      if(g) g.removeAttribute('src');
      d.classList.remove('playing');
    };
    if(fine){
      demos.forEach(function(d){
        d.addEventListener('mouseenter', function(){ on(d); });
        d.addEventListener('mouseleave', function(){ off(d); });
        d.addEventListener('focusin', function(){ on(d); });
        d.addEventListener('focusout', function(){ off(d); });
      });
    } else if(!save && !reduce && 'IntersectionObserver' in window){
      /* CELULAR — arranca la FILA que está más al centro de la pantalla.

         20-sep: antes esto era una cola de dos por orden de llegada: cuando
         entraba una tarjeta nueva se apagaba la más vieja. El problema es que
         las tarjetas de una misma fila no siempre cruzan el umbral del
         observer en el mismo instante, así que a media pantalla quedaba UNA
         tarjeta de la fila de arriba y UNA de la de abajo — y la fila del
         medio, la que el cliente está mirando, nunca arrancaba junta. Eso es
         lo que se veía mal en la portada publicada.

         Ahora no hay cola: en cada recalculo se mide qué tan lejos está cada
         tarjeta del centro de la pantalla y se eligen las dos más cercanas.
         Las dos tarjetas de una misma fila comparten `top` y `bottom`, o sea
         tienen EXACTAMENTE la misma distancia al centro, así que entran y
         salen siempre juntas. Sin empates rotos, sin orden de llegada.

         El recálculo está limitado a uno cada 120 ms y solo corre mientras
         hay alguna tarjeta cerca de la pantalla: 6 mediciones ocho veces por
         segundo, nada que se note. */
      var A_LA_VEZ = 2;
      var activos = [];
      var pendiente = 0, ultimo = 0, enZona = 0;

      var elegir = function(){
        pendiente = 0; ultimo = Date.now();
        var centro = innerHeight / 2, visibles = [];
        demos.forEach(function(d){
          var r = d.getBoundingClientRect();
          if(r.bottom <= 0 || r.top >= innerHeight) return;
          visibles.push({ d: d, dist: Math.abs((r.top + r.bottom) / 2 - centro) });
        });
        visibles.sort(function(a, b){ return a.dist - b.dist; });
        var quiero = visibles.slice(0, A_LA_VEZ).map(function(x){ return x.d; });

        activos.forEach(function(d){ if(quiero.indexOf(d) < 0) off(d); });
        quiero.forEach(function(d){ if(activos.indexOf(d) < 0) on(d); });
        activos = quiero;
      };
      var pedir = function(){
        if(pendiente) return;
        pendiente = setTimeout(elegir, Math.max(0, 120 - (Date.now() - ultimo)));
      };

      var io2 = new IntersectionObserver(function(es){
        es.forEach(function(e){
          var d = e.target;
          if(e.isIntersecting && !d.agmZona){ d.agmZona = 1; enZona++; }
          else if(!e.isIntersecting && d.agmZona){ d.agmZona = 0; enZona--; }
        });
        pedir();
      }, { rootMargin: '150px 0px' });

      addEventListener('scroll', function(){ if(enZona > 0) pedir(); }, { passive: true });
      addEventListener('resize', function(){ pedir(); }, { passive: true });
      whenLoaded(function(){ demos.forEach(function(d){ io2.observe(d); }); pedir(); });
    }
  }
})();

